import UserPrompts from "../components/prompts/UserPrompts";
import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useUserData } from "../context/UserDataContext";
import { useNavigate } from "react-router-dom";
import { subscribeToContinueStories } from "../data/storyRepo";

import BrandBanner from "../components/layout/BrandBanner";
import StoriesRow from "../components/story/StoriesRow";
import DashboardTabs from "../components/dashboard/DashboardTabs";
import TopTenRow from "../components/story/TopTenRow";
import { updateUserStreakOnVisit } from "../utils/streak";
import StreakWidget from "../components/dashboard/StreakWidget";
import FlashcardProgress from "../components/dashboard/FlashcardProgress";
import StoryProgress from "../components/dashboard/StoryProgress";
import { IoCloseSharp } from "react-icons/io5";
import "./Home.css";

import { fetchAllStoryCards } from "../data/storyRepo";

export default function Home() {
  const { user } = useAuth();
  const { userData } = useUserData();
  const [activeTab, setActiveTab] = useState("all");
  const [continueStories, setContinueStories] = useState([]);
  const [beginnerStories, setBeginnerStories] = useState([]);
  const navigate = useNavigate();
  const [showTopSection, setShowTopSection] = useState(true);
  const [allStories, setAllStories] = useState([]);
  const [nivel, setNivel] = useState("Todos");
  const [genero, setGenero] = useState("Todos");
  const [duracao, setDuracao] = useState("Todos");

  const language = "de";   // TEMPORARY — later read from user settings

  const isPaidUser = userData?.hasAccess && userData?.subscriptionStatus === "active";


  // 🔥 Streak tracking (runs once per day)
  useEffect(() => {
    if (!user?.uid) return;
  
    const key = `streakUpdated:${user.uid}:${new Date().toDateString()}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
  
    updateUserStreakOnVisit(user.uid)
      .then(() => console.log("📈 Streak checked for today"))
      .catch((err) => console.error("❌ Error updating streak:", err));
  }, [user]);
  
  useEffect(() => {
    if (!user?.uid || allStories.length === 0) return;
    if (!language) return;
  
    const unsubscribe = subscribeToContinueStories({
      uid: user.uid,
      language,
      onChange: (inProgressDocs) => {
        // keep your safety filter if you want; query already filters
        const inProgressIds = inProgressDocs
          .filter((d) => d.status === "in_progress")
          .map((d) => d.id);
  
        const matchedStories = allStories.filter((s) => inProgressIds.includes(s.id));
        setContinueStories(matchedStories);
      },
      onError: (err) => {
        console.error("❌ Error subscribing to story progress:", err);
        console.error("Firestore message:", err?.message);
        console.error("Firestore code:", err?.code);
      },
    });
  
    return unsubscribe;
  }, [user?.uid, allStories, language]);
  

  // 📚 Load stories old way
  // useEffect(() => {
  //   async function loadStories() {
  //     const baseStories = [
  //       "bio-ayrton-senna",
  //       "bio-bruno-mars",
  //       "bio-elon-musk",
  //       "bio-tim-maia",
  //       "bio-neymar",
  //       "bio-mercury",
  //       "startup-netflix",
  //       "startup-amazon",
  //       "startup-havaianas",
  //       "startup-microsoft",
  //       "startup-apple",
  //       "hist-apollo",
  //       "hist-berlin-wall-fall",
  //       "hist-brasil-discovery",
  //       "hist-jfk",
  //       "hist-roman-empire1",
  //       "gringo-arriving",
  //       "gringo-apartment",
  //       "gringo-supermarket",
  //       "gringo-caipirinha",
  //       "gringo-farofa",
  //       "gringo-futevoley",
  //       "german-5slangs1",
  //       "german-minikurs1",
  //       "german-minikurs2",
  //       "german-minikurs3",
  //       "german-minikurs4",
  //       "german-minikurs5",
  //       "book-atomic-habits",
  //       "mini-oktoberfest",
  //       "mini-autobahn",
  //       "mini-samba",
  //       "mini-5wayshello-german",
  //       "mini-languagelearn",
  //     ];

  //     const loadedStories = await Promise.all(
  //       baseStories.map(async (storyId) => {
  //         const folder = `${storyId}_${language}`; // language-specific folder
  //         const res = await fetch(`/stories/${folder}/story.json`);
  //         const data = await res.json();
      
  //         return {
  //           id: storyId,                // UNIVERSAL ID
  //           title: data.title,
  //           level: data.level,
  //           series: Array.isArray(data.series) ? data.series : [data.series].filter(Boolean),
  //           genres: Array.isArray(data.genres) ? data.genres : [data.genre || "outros"],
  //           top10: data.top10 ?? null,
  //           cardImage: data.cardImage,
  //           coverImage: data.coverImage,
  //           numSentences: data.numSentences,
  //           estimatedMinutes: data.estimatedMinutes,
  //           access: data.access || "paid",
  //         };
  //       })
  //     );
  //     setAllStories(loadedStories);
  //     setContinueStories(loadedStories.slice(0, 2));
  //     setBeginnerStories(loadedStories.slice(2));
  //   }
  
  //   loadStories();
  // }, [language]);

  useEffect(() => {
    fetchAllStoryCards(language).then(setAllStories).catch(console.error);
  }, [language]);
  
  useEffect(() => {
    fetchAllStoryCards(language)
      .then((stories) => {
        console.log("loaded stories", stories);
        setAllStories(stories);
      })
      .catch(console.error);
  }, [language]);

  const top10Stories = allStories
  .filter((story) => story.top10 != null)
  .sort((a, b) => Number(a.top10) - Number(b.top10));

    // Filtering logic
  const filteredStories = allStories.filter((story) => {
    // Nível filter
    const levelMatch =
      nivel === "Todos" ||
      (nivel === "Iniciante" && ["A1", "A2"].includes(story.level)) ||
      (nivel === "Intermediário" && ["B1", "B2"].includes(story.level)) ||
      (nivel === "Avançado" && story.level === "C1");

    // Duração filter
    const durationMatch =
      duracao === "Todos" ||
      (duracao === "Curta" && story.estimatedMinutes <= 13) ||
      (duracao === "Média" &&
        story.estimatedMinutes > 13 &&
        story.estimatedMinutes <= 25) ||
      (duracao === "Longa" && story.estimatedMinutes > 25);


    const genreMap = {
        "Mundo Real": ["history", "true-story", "business", "motivation", "self-improvement"],
        "Educação": ["education", "language-learning", "science"],
        "Cotidiano": ["daily-life", "travel", "funny", "culture"],
      };
    // Gênero filter
    const genreMatch =
    genero === "Todos" ||
    story.genres?.some((g) =>
      genreMap[genero]?.includes(g.toLowerCase())
    );

    return levelMatch && durationMatch && genreMatch;
  });

  const freeStories = filteredStories.filter((s) => s.access === "free");
  const paidStories = filteredStories.filter((s) => s.access !== "free");

  const filteredContinueStories = continueStories.filter((s) =>
    filteredStories.some((f) => f.id === s.id)
  );  

  const biographyStories = filteredStories.filter((story) =>
    story.series?.includes("biography")
  );
  
  const startupStories = filteredStories.filter((story) =>
    story.series?.includes("startup")
  );
  
  const historyStories = filteredStories.filter((story) =>
    story.series?.includes("history")
  );
  
  const gringoStories = filteredStories.filter((story) =>
    story.series?.includes("gringo")
  );
  
  const miniStories = filteredStories.filter((story) =>
    story.series?.includes("mini")
  );
  
  const germanCourseStories = filteredStories.filter((story) =>
    story.series?.includes("german-mini")
  );


  // 🧩 Guard render — fine because this isn't a hook
  if (!user) return <p>Loading dashboard...</p>;


  return (
    <>
      <BrandBanner />

      {/* --- Top background section (Greeting + Progress) --- */}
      {showTopSection && (
        <div className="dashboard-top-bg">
          <div className="dashboard-background-shiny">
            <div className="dashboard-container">
              {/* Close button */}
              <button
                className="dashboard-top-close"
                onClick={() => setShowTopSection(false)}
                aria-label="Close personal progress section"
              >
                <IoCloseSharp size={22} />
              </button>

              {/* Header greeting section */}
              <div className="dashboard-header-section">
                <div className="dashboard-greeting">
                  <h1>Bora aprender, {userData?.name || "Beleza"}! 🚀</h1>
                </div>

              </div>

              {/* Personal progress cards row */}
              <div className="dashboard-progress-column">
              <div className="progress-item">
                <div className="progress-card">
                  <StreakWidget />
                </div>
              </div>
              <div className="progress-item">
                <div className="progress-card">
                  <FlashcardProgress />
                </div>
              </div>

              <div className="progress-item">
                <div className="progress-card">
                  <StoryProgress />
                </div>
              </div>
              </div>
            </div>
            </div>
        </div>
      )}

      {/* ==== Stories ==== */}
      <div className="dashboard-stories-bg">
          <DashboardTabs
            nivel={nivel}
            genero={genero}
            duracao={duracao}
            setNivel={setNivel}
            setGenero={setGenero}
            setDuracao={setDuracao}
          />

          {/* Free users see a "Free Stories" row */}
          {!isPaidUser && freeStories.length > 0 && (
            <StoriesRow title="Histórias Gratuitas" stories={freeStories} />
          )}

          {filteredContinueStories.length > 0 && (
            <StoriesRow title="Continue lendo" stories={filteredContinueStories} />
          )}

          {/* <TopTenRow stories={allStories} /> */}

          {top10Stories.length > 0 && (
            <TopTenRow stories={top10Stories} />
          )}

          {biographyStories.length > 0 && (
            <StoriesRow title="Ícones do Mundo" stories={biographyStories} />
          )}

          {startupStories.length > 0 && (
            <StoriesRow title="Do Sonho ao Negócio" stories={startupStories} />
          )}

          {historyStories.length > 0 && (
            <StoriesRow title="Momentos da História" stories={historyStories} />
          )}

          {gringoStories.length > 0 && (
            <StoriesRow title="Gringo no Brasil" stories={gringoStories} />
          )}

          {miniStories.length > 0 && (
            <StoriesRow title="Mini Histórias" stories={miniStories} />
          )}

          {germanCourseStories.length > 0 && (
            <StoriesRow title="Mini Curso de Alemão" stories={germanCourseStories} />
          )}

          <StoriesRow title="Histórias Filtradas" stories={filteredStories} />
      </div>

      {/* ==== Additional Sections ==== */}
      {/* <UserPrompts /> */}
    </>
  );
}
